import React, { useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import EmployeeInvoiceInfo from '../detail/EmployeeInvoiceInfo';
import CustomTimeInput from '../tables/shared/CustomTimeInput';
import { addMonth } from '../tables/shared/FormatDetails';
import sv from 'date-fns/locale/sv';
import { useTranslation } from 'react-i18next';
import { EMPLOYEE_DETAILS_NO_BILLING_INFO } from '../../i18n/keyConstants';
registerLocale('sv', sv);


const InvoiceInfo = ({ invoiceInfo }) => {
    const [startDate, setStartDate] = useState(addMonth(new Date(), -1));
    const [endDate, setEndDate] = useState(addMonth(new Date(), -1));
    const { t } = useTranslation(['employeeDetails']);


    const updateStartDate = (date) => {
        setStartDate(date);
        if (endDate < date) setEndDate(date);
    };

    return (
        <>
            {invoiceInfo && invoiceInfo.invoiceInfo ? (
                <section>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 col-md-8 offset-md-2'>
                                <div className='row'>
                                    <div className='col-12 col-lg-10 offset-lg-1'>
                                        <div className='padding-top-30px d-flex justify-content-between align-items-center'>
                                            <span>
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={(date) => updateStartDate(date)}
                                                    dateFormat='yyyy-MM'
                                                    customInput={<CustomTimeInput />}
                                                    showMonthYearPicker
                                                    minDate={new Date(invoiceInfo.firstInvoice)}
                                                    maxDate={new Date()}
                                                    locale='sv'
                                                />
                                            </span>
                                            <span className='oi oi-arrow-right padding-left-15px padding-right-15px'></span>
                                            <span>
                                                <DatePicker
                                                    selected={endDate}
                                                    onChange={(date) => setEndDate(date)}
                                                    dateFormat='yyyy-MM'
                                                    customInput={<CustomTimeInput />}
                                                    showMonthYearPicker
                                                    minDate={startDate}
                                                    maxDate={new Date()}
                                                    locale='sv'
                                                    popperPlacement='bottom-end'
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <EmployeeInvoiceInfo invoiceInfo={invoiceInfo.invoiceInfo} startDate={startDate} endDate={endDate} />
                    </div>
                </section>
            ) : (
                <div className='col-10 offset-1 col-md-6 offset-md-3 col-lg-4 offset-lg-4 padding-top-30px'>
                        <p className='text-center'>{t(EMPLOYEE_DETAILS_NO_BILLING_INFO)}</p>
                </div>
            )}
        </>
    );
};

export default InvoiceInfo;
